module.exports = __webpack_public_path__ + "static/media/chest_pain.adfdced8.jpg";